export const terms = {
    "2": "Duties Collect",
    "3": "All Prepaid",
}

export const newTerms = {
    "1": "All Collect",
    "2": "Duties Collect",
    "3": "All Prepaid",
    "4": "Item Prepaid",
    "7": "Item Collect",
    "c": "Item Duties Collect"
}

export const needCollectAmountTerms = [
  "7", "c",
]

export const GSTPaidCountry = ["SG"]

export const preferredTime = {
    "00": "NO PREFERENCE",
    "AM": "8AM - 12PM",
    "14": "2PM - 4PM",
    "16": "4PM - 6PM",
    "18": "6PM - 8PM",
    "19": "7PM - 9PM",
}

export const weightUnit = [
    "LBS",
    "OPT",
    "USD"
]

export const LimitTimeNoActive = 3600000

export const orderStatus = {
    AWAITING_FINALIZATION: 7,
    AWAITING_SHIPMENT: 8,
    SENT_TO_SHIPMENT: 9,
    SENT_TO_SHIPMENT_5: 5,
    SENT_TO_SHIPMENT_6: 6,
    CANCEL: 10,
    SPLIT: 17,
    FULFILLMENT_IN_HOUSE: 1,
    FULFILLMENT_YAMATO: 2
}
export const shipmentStatus = {
    AWAITING_PACKAGE_INFO: 1,
    READY_TO_PRINT: 2,
    READY_TO_TRANSMIT: 3,
    TRANSMITED: 4,
    TRANSMITED_KTE: 5,
    IMPORTED_KTE: 6,
    SHIPPED: 11,
    ARRIVED_AT_DESTINATION: 12,
    OUT_FOR_DELIVERY: 13,
    DELIVERY_DELIVERED: 14,
    DELETED: 15,
    PENDING_TRANSMIT: 16,
    FULFILLMENT_IN_PROCESS: 18,
    SHIPPING_IN_PROCESS: 19,
    FULFILLMENT_COMPLETED: 20,
    PENDING_SHIPPING_IN_PROCESS: 21,
    TRANSMIT_FAIL: 40
}

/**
 * The status of the feed send to original system
 */
export const feedTransmitStatus = {
    PROCESSING: 1,
    SUCCESS: 2,
    PARTIAL_SUCCESS: 3,
    FAIL: 4,
    CLEAR: 5
}

export const StatusFilterShipment = {
    AWAITING_PACKAGE_INFO: 1,
    READY_TO_PRINT: 2,
    READY_TO_TRANSMIT: 3,
    SHIPPED: 4,
    IN_TRANSIT: 5,
    DELIVERED: 6,
    FULFILLMENT_IN_PROCESS: 18,
    SHIPPING_IN_PROCESS: 19,
    FULFILLMENT_COMPLETED: 20,
    PENDING_SHIPPING_IN_PROCESS: 21,
    TRANSMIT_FAIL: 40
}

export const shipmentStatusShow = {
    1: "Awaiting Package Info",
    2: "Ready To Print",
    3: "Ready To Transmit",
    4: "Transmitted",
    5: "Transmitted",
    6: "Imported KTE",
    11: "Shipped",
    12: "Arrived At Destination",
    13: "Out For Delivery",
    14: "Delivery Delivered",
    15: "Deleted",
    16: "Pending Transmit",
    18: "Fulfillment In Process",
    19: "Shipping In Process",
    20: "Fulfillment Completed",
    21: "Pending Shipping In Process",
    40: "Transmission Error"
}

export const mechantSettings = {
    Maintenance: 'Maintenance',
    Update: 'Update'
}

export const permissions = {
    UserUpdate: "User-Update",
    PrinterSavePrinterSetting: "Printer-SavePrinterSetting",
    EcCredentialSaveSetting: "EcCredential-SaveSetting",
    EcCredentialGetSetting: "EcCredential-GetSetting",
    ItemNameUpdateItemName: "ItemName-UpdateItemName",
    ShipmentUpdatePackageStatus: "Shipment-UpdatePackageStatus",
    ShipmentDeleteShipment: "Shipment-DeleteShipment",
    ShipmentClearTransmissionErrorStatus: "Shipment-ClearShipmentFailTransmitFeed",
    ShipmentUpdatePackageInfo: "Shipment-UpdatePackageInfo",
    ShipmentGetPrintLabelInfo: "Shipment-GetPrintLabelInfo",
    OrderAddShipmentAndPackage: "Order-AddShipmentAndPackage",
    OrderDelete: "Order-DeleteOrderById",
    OrderUpdateOrder: "Order-UpdateOrder",
    OrderCreateNewOrder: "Order-CreateNewOrder",
    ImportUpload: "Import-ImportFromFile",
    OrderSync: "Order-Sync",
    ImportSaveImportingOrder: 'Import-SaveImportingOrders',
    SwitchShipper: ["Access-Multiple-Shipper", "Access-All-Shipper"],
    PrinterGetPrinterSetting: "Printer-GetPrinterSetting",
    ItemNameSearchAll: "ItemName-SearchAll",
    ItemNameImportItemName: "ItemName-ImportItemName",
    ItemNameDeleteItemNames: "ItemName-DeleteItemNames",
    ItemNameDeleteAllItemNames: "ItemName-DeleteAllItemNames",
    ItemNameExport: "ItemName-Export",
    ItemNameUpdateItemNameSetting: "ItemName-UpdateItemNameSetting",
    OrderSplitOrder: 'Order-SplitOrder',
    ShipmentExportFeed: "Shipment-ExportFeed",
    MFASetUp: "MFA-Setup"
}

export const SORT_ITEM_BY = {
    SKU: "SKU",
    CreatedDT: 'CreatedDT',
    CreatedDT_DESC: 'CreatedDT_DESC',
}

export const settingPrintOptions = {
    ShippingLabelOnly: 1,
    PackingListOnly: 2,
    ShippingLabelAndPacking: 3
}

export const ServiceType = {
    K: "TA-Q-BIN",
    M: "NEKOPOST",
    H: "OVERSIZE",
}

export const FulfillOption = {
    YAMATO: {
        CODE: 2,
        NAME: 'Fulfillment by Yamato',
        TYPE_LINK: 'yamato',
    },
    IN_HOUSE: {
        CODE: 1,
        NAME: 'In-House',
        TYPE_LINK: 'in-house'
    }
}

export const TimeExpiresCookieProhibited = 30 // day
export const PerfixCookieNotDelete = "PerfixCookieNotDelete_"
export const KeyCookieDisplayNewUpdateProhibited = PerfixCookieNotDelete + 'DisplayNewUpdateProhibited';
export const KeyCookieDisplayContentWarningProhibited = PerfixCookieNotDelete + 'DisplayContentWarningProhibited';
export const KeyCookieLastUpdateItemProhibited = PerfixCookieNotDelete + 'LastUpdateItemProhibited';
export const KeyCookieLastUpdateItemProhibitedLocal = PerfixCookieNotDelete + 'KeyCookieLastUpdateItemProhibitedLocal';
export const MaxNoOfPackages = 30;



// WEBPACK FOOTER //
// ./src/constants/index.js